import src from "./case-empty.png";
export default { src: src, aspect: 0.3175, width: 214, height: 674 };